import { render, staticRenderFns } from "./RecoverPass.vue?vue&type=template&id=f3c39c6c"
import script from "./RecoverPass.vue?vue&type=script&lang=js"
export * from "./RecoverPass.vue?vue&type=script&lang=js"
import style0 from "./RecoverPass.vue?vue&type=style&index=0&id=f3c39c6c&prod&scooped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports